import { CommonConfig, common as commonCore, } from "src/index";

export const common: CustomCommonConfig = {
    ...commonCore,
    // Impostare qui gli override per i valori della configurazione comune tra sviluppo e produzione
    id: 'h2iosc',
    name: 'H2IOSC',
    instanceVersion: '1.4.3',
    defaultLanguage: 'it',
    multiLanguage: true,
    availableLanguages: ['en', 'it'],
    customLanguageResourcesPrefixes: ['/assets/i18n/'],

    logo: 'assets/images/Logo_training_environment_white.png',
    enablePrivacyDisclaimer: true,
    hideFooter: false,
    footerText: ``, // FOOTER gestito con componente custom
    hideMetaCredits: true,

    hideChat: true,
    hideChatToggler: true,

    enableCodeOfConductDisclaimer: true,
    enableCourseUnsubscription: true,

    myCoursesModule: {
        hideAdvancedSearch: true,
        provideCertificate: true,
        certificateLogos: ['assets/images/Logo_H2IOSC_colori_extended.jpg', 'assets/images/logo-ilc.png', 'assets/images/logo_CLARIN-IT.png'],
        coursesPreviewConfig: {
            showImage: true,
            showDescription: true,
            showProgress: true,
        }
    },
    myGuidesModule: {
        hideAdvancedSearch: true,
    },
    globalSearchModule: {
        ...commonCore.globalSearchModule,
        searchInputPlaceholder: 'Search in H2IOSC',
        contentsPreviewConfig: {
            showImage: true,
            showDescription: true,
            showSkills: true,
            showContentTypeIcon: true,
        },
    },
    calendarModule: {
        ...commonCore.calendarModule,
        showFilterByMyCourses: true,
        facetField: 'infrastructure',
        colorPalette: [
            ...commonCore.calendarModule?.colorPalette ?? [] // To customize comment this line and add custom colors
        ],
    },
    viewerModule: {
        ...commonCore.viewerModule,
        trackProgressType: 'manual',
        toolbar: {
            config: {
                ...commonCore.viewerModule?.toolbar?.config ?? {},
                activeToolId: 'index',
            },
        },
        liquidViewer: {
            ...commonCore.viewerModule?.liquidViewer,
            customCssPath: 'assets/liquidViewerCustomizations.css',
        },
    },

    registrationModule: {
        hideSkillsSetting: true,
        registrationType: 'simple',
        privacyDisclaimer: 'flag',
    },

    loginModule: {
        logoExternalLink: 'https://www.h2iosc.cnr.it/',
        logoExternalLinkTitle: 'Go to H2IOSC Project',
        pageTitle: 'Welcome to the H2IOSC training environment',
        pageSubtitle: 'Log in with your credentials or create an account',
        customMessage: 'Discover more about the platform',
        customMessagePosition: 'below-registration'
    },

    coursePreview: `${commonCore.baseContentUrlApi}/course/:uuidCourse`,

    dashboardModule: {
        ...commonCore.dashboardModule,
        hideSidebarOnMobile: false,
    },

    analytics: {
        ...commonCore.analytics,
        enable: true,
        type: 'InternalTracking',
    }
};

interface CustomCommonConfig extends CommonConfig {
    coursePreview: string;
}